import { createActions } from 'redux-actions';

export const {
  getRequestProfiles,
  getRequestProfilesSuccess,
  getRequestProfilesError,
} = createActions(
  'GET_REQUEST_PROFILES',
  'GET_REQUEST_PROFILES_SUCCESS',
  'GET_REQUEST_PROFILES_ERROR'
);
